import { render, staticRenderFns } from "./newsManage.vue?vue&type=template&id=6d6c64a8&scoped=true"
import script from "./newsManage.vue?vue&type=script&lang=js"
export * from "./newsManage.vue?vue&type=script&lang=js"
import style0 from "./newsManage.vue?vue&type=style&index=0&id=6d6c64a8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6c64a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d6c64a8')) {
      api.createRecord('6d6c64a8', component.options)
    } else {
      api.reload('6d6c64a8', component.options)
    }
    module.hot.accept("./newsManage.vue?vue&type=template&id=6d6c64a8&scoped=true", function () {
      api.rerender('6d6c64a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_homeCloudPlatform/article/newsManage.vue"
export default component.exports